<template>
  <el-radio-group
    v-if="isDesktop"
    v-model="value"
    class="desktop"
    :disabled="disabled"
    @update:modelValue="update"
  >
    <el-radio-button v-if="withEmpty" key="all" :value="0">
      All types
    </el-radio-button>
    <el-radio-button
      v-for="protocol in ProtocolTypeLabels"
      :key="protocol.type_id"
      :value="protocol.type_id"
    >
      {{ protocol.label }}
    </el-radio-button>
  </el-radio-group>
  <el-select
    v-else
    v-model="value"
    :disabled="disabled"
    @update:modelValue="update"
  >
    <el-option v-if="withEmpty" key="all" label="All types" :value="0">
      All types
    </el-option>
    <el-option
      v-for="protocol in ProtocolTypeLabels"
      :key="protocol.type_id"
      :label="protocol.label"
      :value="protocol.type_id"
    >
      {{ protocol.label }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { ProtocolTypeLabels } from '@/api/types'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'ProtocolSelector',
  props: {
    modelValue: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    withEmpty: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const update = function (newValue: any) {
      context.emit('update:modelValue', newValue)
    }

    const { isDesktop } = useResize()

    return { update, isDesktop, ProtocolTypeLabels, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
:deep(.el-radio-button__orig-radio:checked + .el-radio-button__inner) {
  box-shadow: none;
}
</style>
